<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';
    import { Icon } from '@oat-sa-private/ui-elements';
    export let data;
    const tooltip = __('Interpreter assistance is being provided during this test');

    $: name = data?.name || '';
    $: span = data?.span;
</script>

<style>
    .content {
        display: flex;
        align-items: center;
        gap: 1rem;


        & .candidate-name {
            margin: 0;
        }
    }

    .secondary {
        color: var(--color-text-feedback);
        font-size: var(--fontsize-body-s);
        margin-top: 0.25rem;
        display: block;
    }
</style>

<div class="content">
    <p class="candidate-name">{name}</p>

    {#if data?.flagLanguageAccommodation}
        <span title={tooltip} aria-label={tooltip}>
            <Icon name="interpret-16" ariaHidden={true} />
        </span>
    {/if}
</div>

{#if span}
    <span class="secondary">{span}</span>
{/if}
    